import { i18nLocale } from '@weavix/models/src/translate/translate';
import { parseLanguage } from './parse-language';

/** The secondary language that counts: null when unset or equal to the primary, which defaults to English. */
export function effectiveSecondaryLocale(primaryLocale: string | null | undefined, secondaryLocale: string | null | undefined): i18nLocale | null {
    if (!secondaryLocale || secondaryLocale === (primaryLocale || 'en')) return null;
    return secondaryLocale as i18nLocale;
}

/** A user's languages: their primary (English when unset), then their secondary when they have one distinct from it. */
export function listenerLanguages(primaryLocale: string | null | undefined, secondaryLocale: string | null | undefined): i18nLocale[] {
    const primary = (primaryLocale || 'en') as i18nLocale;
    const secondary = effectiveSecondaryLocale(primary, secondaryLocale);
    return secondary ? [primary, secondary] : [primary];
}

/** Whether any of `languages` (locales or full languages like `es-MX`) is one of `mine`, compared by language subtag. */
export function speaksAnyOf(mine: ReadonlyArray<string>, ...languages: Array<string | null | undefined>): boolean {
    return languages.some(language => {
        const [locale] = parseLanguage(language);
        return !!locale && mine.includes(locale);
    });
}
